import {
  faBars,
  faChalkboardTeacher,
  faChartArea,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type Dispatch, type SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import styles from './Controls.module.css';
import type { DataRequested } from '../../types/app.types';

type Props = {
  isMegs: boolean;
  setNavRequired: Dispatch<SetStateAction<boolean>>;
  handleVersionSwitch: () => void;
  dataRequested: DataRequested;
  version: string;
};

export const ControlHeader = ({
  isMegs,
  setNavRequired,
  handleVersionSwitch,
  dataRequested,
  version,
}: Props) => {
  const displayYear =
    dataRequested.year === 'current'
      ? dataRequested.country === 'uk'
        ? 2020
        : new Date().getFullYear()
      : dataRequested.year;

  return (
    <div className={styles.controlHeader}>
      <Link to='/' className={styles.headerHomeBtn}>
        <FontAwesomeIcon icon={faHome} />
      </Link>

      <div className={styles.headerCenter}>
        <span
          className={styles.headerTitle}
          style={{ color: isMegs ? '#ff4444' : 'white' }}
        >
          {isMegs ? 'MEGS' : 'ESx'}
        </span>
        <span className={styles.headerSubtitle}>
          {dataRequested.country.toUpperCase()} · {displayYear}
        </span>
      </div>

      <div className={styles.headerActions}>
        {dataRequested.dataset !== 'megs' && (
          <button
            className={styles.headerIconBtn}
            onClick={handleVersionSwitch}
            title={
              version === 'educational'
                ? 'Switch to Scientific'
                : 'Switch to Educational'
            }
          >
            <FontAwesomeIcon
              icon={version === 'educational' ? faChartArea : faChalkboardTeacher}
            />
          </button>
        )}
        <button
          className={styles.headerIconBtn}
          onClick={() => setNavRequired((prevState) => !prevState)}
          title='Open menu'
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
    </div>
  );
};
